import { themr } from '@friendsofreactjs/react-css-themr';

import PaymentIcon from './components/PaymentIcon';

export default themr('PaymentIcon')(PaymentIcon);
